<template>
  <el-dialog title="基本信息" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="18">
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="tenantname" >
          <el-input v-model="form.tenantname" auto-complete="off" :required="true" style="width: 70%;margin-right: 20px"></el-input> <el-checkbox label="直营店" v-model="directstore"></el-checkbox>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="网址：" :label-width="formLabelWidth" prop="website" style="width: 70%">
          <el-input v-model="form.website" auto-complete="off" :required="true" placeholder="格式：vue.zyanjing.com"></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-col :span="8">
          <el-form-item label="有效期：" :label-width="formLabelWidth" prop="enddatetime" >
            <el-date-picker style="width:150px" v-model="form.enddatetime" :value-format="'yyyy-MM-dd'" :required="true" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="管理员：" :label-width="formLabelWidth" prop="contactname">
            <el-input v-model="form.contactname" auto-complete="off" :required="true" :disabled="form.unitguid?true:false"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机号：" :label-width="formLabelWidth" prop="contactphone" >
            <el-input v-model="form.contactphone" auto-complete="off" :required="true" :disabled="form.unitguid?true:false"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="功能：" :label-width="formLabelWidth" prop="params" style="width: 70%">
          <el-checkbox-group v-model="params.module">
            <el-checkbox label="预检"></el-checkbox>
            <el-checkbox label="订单管理"></el-checkbox>
            <el-checkbox label="简易开单"></el-checkbox>
            <el-checkbox label="视光档案"></el-checkbox>
            <el-checkbox label="Airdoc"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="最低折扣：" :label-width="formLabelWidth" prop="params" >
            <el-input-number v-model="form.minidiscount" auto-complete="off" :controls="false" :min="1" :max="10" style="width: 80%"></el-input-number>折
          </el-form-item>
        </el-col>
        <template v-if="form.unitguid&&form.unitguid!='d6d0f500-6c34-45e6-b206-b87c368e4469'">
          <el-col :span="8">
            <el-form-item label="银联一：" :label-width="formLabelWidth" prop="params" >
              <el-input v-model="unionset['银联']" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银联二：" :label-width="formLabelWidth" prop="params" >
              <el-input v-model="unionset['银联二']" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银联三：" :label-width="formLabelWidth" prop="params" >
              <el-input v-model="unionset['银联三']" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银联四：" :label-width="formLabelWidth" prop="params" >
              <el-input v-model="unionset['银联四']" auto-complete="off"></el-input>
            </el-form-item>
          </el-col><el-col :span="8">
          <el-form-item label="银联五：" :label-width="formLabelWidth" prop="params" >
            <el-input v-model="unionset['银联五']" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>

        </template>
      </el-row>
      <el-row :gutter="24" v-if="form.unitguid&&form.unitguid!='d6d0f500-6c34-45e6-b206-b87c368e4469'">
        <el-col :span="6">
          <el-form-item label="提成比例：" :label-width="formLabelWidth" >
            <el-input v-model="provision" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="入账公司：" :label-width="formLabelWidth" >
            <el-select v-model="usechild" style="width: 300px" >
              <el-option :label="item.name" :value="item.code" :key="item.code" v-for="item in sysunionlist"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="每月限额：" :label-width="formLabelWidth" prop="params" >
            <el-input v-model="quarterlylimit" auto-complete="off" style="width: 80px"></el-input>元
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="18" v-if="false">
        <el-col :span="9">
          <el-form-item label="开通用户数：" :label-width="formLabelWidth" prop="registereduser" style="width: 70%">
            <el-input-number v-model="form.registereduser" :min="1" :disabled="form.unitguid?true:false"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="授权用户数：" :label-width="formLabelWidth" prop="authorizeuser" style="width: 70%">
            <el-input-number v-model="form.authorizeuser" :min="1" :disabled="form.unitguid?true:false"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="false">
        <el-col :span="8">
          <el-form-item label="启用会员：" :label-width="formLabelWidth" prop="ifusemember">
            <el-radio-group v-model="form.ifusemember" :disabled="form.unitguid?true:false">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="使用存货：" :label-width="formLabelWidth" prop="ifusestore">
            <el-radio-group v-model="form.ifusestore" :disabled="form.unitguid?true:false">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="启用总账：" :label-width="formLabelWidth" prop="ifuseaccount">
            <el-radio-group v-model="form.ifuseaccount" :disabled="form.unitguid?true:false">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="18" v-if="false">
        <el-form-item label="会员名称：" :label-width="formLabelWidth" prop="membername" style="width: 70%">
          <el-input v-model="form.membername" auto-complete="off" :required="true" :disabled="form.unitguid?true:false"></el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
      <el-button type="primary" @click="saveData" :loading="CanEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {sysmanagesaveData, sysmanageDetail,sysupdateparacontent,parameterMaintainList} from '@/api/sysmanage/sysmanage';

  export default {
    name: "ManageTenantEdit",
    data() {
      return {
        dialogFormVisible: false,
        CanEdit: false,//防止多次提交
        sysunionpay:[],
        sysunionlist:[],
        directstore:false,
        form: {  //表单数据
          unitguid: '',
          tenantname: '',//名称
          website: '',//网址
          contactname: '',//管理员
          contactphone: '',//手机号
          registereduser: '',//开通用户数
          authorizeuser: '',//授权用户数
          ifuseaccount: 0,//是否启用总账0 否  1 是
          ifusemember: 1,//启用会员系统 0 否  1 是
          membername: '',//会员系统名称
          ifusestore: 0,//是否使用存货管理 0 否  1 是
          directstore:-1,//直营门店
          minidiscount:null,
          params: "",
          enddatetime:null
        },
        unionset:{"银联":"","银联二":"","银联三":"","银联四":"","银联五":""},
        provision:'6',
        quarterlylimit:'',
        usechild:'',
        params: {module: []},
        formLabelWidth: '120px',
        radio: [{label: 1, name: '是'}, {label: 0, name: '否'}],
        rules: {////////定义正则验证字段。
          tenantname: [
            {required: true, message: '请输入名称', trigger: 'blur'},
          ],
          website: [
            {required: true, message: '请输入网址', trigger: 'blur'},
          ],
          contactname: [
            {required: true, message: '请输入管理员', trigger: 'blur'},
          ],
          contactphone: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
          ],
          enddatetime: [
            {required: true, message: '有效期必填', trigger: 'blur'},
          ],
        },
      }
    },
    methods: {
      show() {
        this.dialogFormVisible = true
        this.initForm()
      },
      padZero(num){
        if(num<10) return '0'+num;
        return num;
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.CanEdit = true
            this.params.module = this.params.module.join(';');
            this.form.params = JSON.stringify(this.params);
            this.form.directstore=this.directstore?1:-1;
            if(!this.form.minidiscount) this.form.minidiscount=0;
            if(this.form.enddatetime) {
              var rzrq = new Date(this.form.enddatetime);
              this.form.enddatetime = rzrq.getFullYear() + '-' + this.padZero(rzrq.getMonth() + 1) + '-' + this.padZero(rzrq.getDate());
            }
            sysmanagesaveData(this.form).then(response => {
              if (response.data.code == 0) {
                if (this.form.unitguid && this.form.unitguid != 'd6d0f500-6c34-45e6-b206-b87c368e4469') {
                  var unionParam = "";
                  if (this.unionset["银联"] || this.unionset["银联二"] || this.unionset["银联三"]) {
                    unionParam = JSON.stringify(this.unionset);
                  }
                  sysupdateparacontent({
                    tenantid: this.form.unitguid,
                    paragroup: 'unionpay',
                    fiscalsysguid: 'mid',
                    paraname: '银联商户号',
                    paracontent: unionParam
                  }).then(res => {
                    sysupdateparacontent({
                      tenantid: this.form.unitguid,
                      paragroup: 'unionpay',
                      fiscalsysguid: 'provision',
                      paraname: '计提比例',
                      paracontent: this.provision
                    }).then(res2 => {
                      var cusname = '';
                      for (let i in this.sysunionlist) {
                        if (this.sysunionlist[i].code == this.usechild)
                          cusname = this.sysunionlist[i].name;
                      }
                      sysupdateparacontent({
                        tenantid: this.form.unitguid,
                        paragroup: 'unionpay',
                        fiscalsysguid: 'usechild',
                        paraname: cusname,
                        paracontent: this.usechild
                      }).then(res3 => {

                        sysupdateparacontent({
                          tenantid: this.form.unitguid,
                          paragroup: 'unionpay',
                          fiscalsysguid: 'quarterlylimit',
                          paraname: '季度最高限额',
                          paracontent: this.quarterlylimit
                        }).then(res4 => {


                        });

                      });
                    });
                  });
                }

                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false
                //刷新列表
                this.$emit('bindGuid');

              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
                this.CanEdit = false
              }
            });
          }
        })
      },
      getSysparam(fiscalsysguid) {
        for (let i in this.sysunionpay) {
          if (this.sysunionpay[i].fiscalsysguid == fiscalsysguid) {
            return this.sysunionpay[i].paracontent;
          }
        }
        return '';
      },
      initData(unitguid) {
        this.provision = this.getSysparam('provision');
        this.usechild = '';
        this.quarterlylimit = '';
        this.form.unitguid = unitguid
        this.unionset = {"银联": "", "银联二": "", "银联三": ""};
        sysmanageDetail({unitguid: unitguid}).then(response => {
          for (let i in this.form) {
            if (i == 'minidiscount') {
              this.form[i] = response.data.obj[i] > 0 ? response.data.obj[i] : undefined;
            } else {
              this.form[i] = response.data.obj[i]
            }
          }
          this.directstore=this.form.directstore==1;
          if (this.form.params) {
            var param = JSON.parse(this.form.params);
            this.params.module = param.module.split(";");
          } else {
            this.params.module = [];
          }
          if (this.form.unitguid && this.form.unitguid != 'd6d0f500-6c34-45e6-b206-b87c368e4469') {
            parameterMaintainList({tenantid: unitguid, paragroup: 'unionpay'}).then(reParam => {
              for (let i in reParam.data.obj) {
                var row = reParam.data.obj[i];
                if (row.fiscalsysguid == 'mid') {
                  try {
                    if (row.paracontent)
                      this.unionset = JSON.parse(row.paracontent);
                  } catch (ex) {
                  }
                } else if (row.fiscalsysguid == 'provision') {
                  if (row.paracontent) {
                    this.provision = row.paracontent;
                  }
                } else if (row.fiscalsysguid == 'usechild') {
                  if (row.paracontent && row.paracontent.toString() == 'true') {
                    this.usechild = row.paracontent;
                  }
                } else if (row.fiscalsysguid == 'quarterlylimit') {
                  if (row.paracontent) {
                    this.quarterlylimit = row.paracontent;
                  }
                }
              }
            });
          }
        });
      },
      initForm() {
        for (let i in this.form) {
          this.form[i] = ""
        }
        this.form.directstore = -1;
        this.directstore = false;
        this.form.minidiscount = undefined;
        this.form.ifuseaccount = 0
        this.form.ifusemember = 1
        this.form.ifusestore = 0
        this.CanEdit = false
      },
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      parameterMaintainList({tenantid: this.userInfoModel.tenantid, paragroup: 'unionpay'}).then(reParam => {
        this.sysunionpay = reParam.data.obj;
        for (let i in this.sysunionpay) {
          var row = this.sysunionpay[i];
          if (row.fiscalsysguid == 'orgname') {
            this.sysunionlist.push({name: row.paracontent, code: ''});
          } else if (row.fiscalsysguid == 'orgnamechild') {
            if (row.paracontent)
              this.sysunionlist.push({name: row.paracontent, code: 'true'});
          }
        }
      });
    },
    components: {}
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }

  .serverAlertCss {
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sysmanage/managgetenant/ManageTenantEdit.vue